import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=cdf5547c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf5547c"]])

export default __exports__